import React from 'react';
import { Spinner } from './Spinner';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /** Show a spinner + busyLabel and disable the button (e.g. while submitting). */
    busy?: boolean;
    busyLabel?: string;
}

// Editorial button (the `.btn` token pattern). Adds a busy/loading state with a spinner.
export const Button = ({ busy = false, busyLabel = 'Working…', children, className = '', disabled, type = 'button', ...rest }: ButtonProps) => (
    // eslint-disable-next-line react/button-has-type
    <button type={type} disabled={busy || disabled} className={`btn disabled:opacity-70 ${className}`} {...rest}>
        {busy ? (
            <span className="inline-flex items-center gap-2">
                <Spinner />
                {busyLabel}
            </span>
        ) : (
            children
        )}
    </button>
);
